import CopyableID from 'components/CopyableID';
import HubertDialog from 'components/HubertUI/HubertDialog';
import { ECreateQuestionMode } from 'components/Questionsv2/builder/context/create-question.context';
import CreateQuestionContainerv2 from 'components/Questionsv2/builder';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toggleEditQuestionDialog } from 'rtk/layout/LayoutControlSlice';
import { useAppDispatch, useAppSelector } from 'rtk/query/hooks';
import type { TAnyClientQuestionType } from '@hubertai/screening-question-types';

const EditQuestionDialog = () => {
  const { t } = useTranslation('Questionsv2');
  const dispatch = useAppDispatch();
  const Layout = useAppSelector((state) => state.Layout.editQuestionDialog);
  const question: TAnyClientQuestionType | null = Layout && Layout.data ? Layout.data.question : null;
  const [language, setLanguage] = useState<string>();

  useEffect(() => {
    setLanguage(question && question.available_languages ? question.available_languages[0] : '');
  }, [question]);

  const customContainer = document.getElementById('main-content') as HTMLElement;
  return (
    <HubertDialog
      open={Layout.show}
      // overlay={true}
      // modal={true}
    >
      <HubertDialog.Content
        title={
          <div className="flex flex-row gap-2 p-4 align-baseline">
            <span>{t('editQuestionDialog.title')}</span>{' '}
            <CopyableID id={question ? question.id : ''} readOnly={true} showCopyButton={false} />
          </div>
        }
        position="center"
        portalContent={true}
        portalElement={customContainer}
        className="flex h-[90vh] max-h-[90vh] w-full max-w-[90%] min-w-[90%] flex-col"
      >
        {!question || !language ? (
          <div className="h-full" />
        ) : (
          <CreateQuestionContainerv2
            className="flex min-h-0 flex-1 flex-col"
            mode={ECreateQuestionMode.Edit}
            nodeId={question.id}
            onCancel={() => {
              dispatch(toggleEditQuestionDialog({ show: false, data: null }));
            }}
            saveProps={{
              buttonText: t('editQuestionDialog.updateButton'),
            }}
          />
        )}
      </HubertDialog.Content>
    </HubertDialog>
  );
};

export default EditQuestionDialog;
